<template>
  <div class="webphone-aside__nav">
    <web-phone-link
      v-for="link in WebPhoneNestedLinks"
      :key="link.name"
      :link="link"
    />
  </div>
</template>

<script>
  import WebPhoneLink from './WebPhoneNavLink.vue';
  export default {
    name: 'WebphoneNav',
    components: {
      WebPhoneLink,
    },
    computed: {
      WebPhoneNestedLinks() {
        return [
          {
            path: '/call-center/webphone/dial',
            name: this.$t('call_center.dial'),
          },
          {
            path: '/call-center/webphone/call-log',
            name: this.$t('call_center.call_log'),
          },
          {
            path: '/call-center/webphone/contacts',
            name: this.$t('call_center.contacts'),
          },
        ];
      },
    },
  };
</script>

<style lang="scss" scoped>
  .webphone-aside {
    &__nav {
      display: flex;
      align-items: stretch;
    }
  }
</style>
